import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getCustomerRestaurantOrderDetailRequest, getCustomerRestaurantOrderDetailRequestError, getCustomerRestaurantOrderDetailRequestSuccess } from "../../slices/Order/CustomerRestaurantOrderDetailSlice";

export const CustomerRestaurantOrderDetailApi = (id) => async (dispatch) => {

    const urlWithParams = `${endpoints.customer_restaurant_order_detail}/${id}`;
    try {
        dispatch(getCustomerRestaurantOrderDetailRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getCustomerRestaurantOrderDetailRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getCustomerRestaurantOrderDetailRequestError(_error));
            });
    } catch (error) {
    }
};
